import React from 'react';
import styles from './input-request.module.scss';

export default function InputRequest({ firstPage }) {
  return (
    <div className={styles.inputRequest}>
      {firstPage
        ? (
          <div>

            <span>
              Please fill out the form below so we can find the best loan for you. Our team will evaluate your situation and recommend the most appropriate loan options. Or, if you’d prefer, feel free to call us at
              {' '}
              <a href="tel: +1-800-460-1620" className={styles.telephoneLink}>
                (800) 460-1620.
              </a>
            </span>
            <div className={styles.secondText}>
              <strong>NOTE:</strong>
              {' '}
              This is a request for information about a business home equity line of credit, not a loan application. Requesting this proposal will not affect your credit in any way. All offers of credit are subject to credit, approval, and membership eligibility. All credit union rates, terms, and programs are subject to change at any time.
            </div>
          </div>
        )
        : (
          <span>
            If at any point you'd prefer to talk directly to a loan officer, feel free to call us at
            {' '}
            {' '}
            <a href="tel: +1-800-460-2889" className={styles.telephoneLink}>
              (800) 460-2889.
            </a>
          </span>
        )}
    </div>
  );
}
